var React = require('react');

function DropInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.5 6L0 0H9L4.5 6Z","fill":"#40196D"}));
}

DropInline.defaultProps = {"width":"9","height":"6","viewBox":"0 0 9 6","fill":"none"};

module.exports = DropInline;

DropInline.default = DropInline;
